import { StateMachine } from 'stateless';
import { BehaviorSubject, from, map, Subject, tap } from 'rxjs';

export class ObservableMachine<TState, TTrigger> {

    private readonly stateSubject = new BehaviorSubject<TState>(this.wrapped.state);
    state$ = this.stateSubject.asObservable();
  
    private readonly permittedTriggerSubject = new BehaviorSubject<TTrigger[]>([]);
    permittedTriggers$ = this.permittedTriggerSubject.asObservable();
  
    stateIs$(state: TState) {
      return this.state$.pipe(map(s => s === state ? true : false))
    }

    // i think this will only update on state change and therefore m
    canFire$(trigger: TTrigger) {
      return this.permittedTriggers$.pipe(
        map( triggers => triggers.find( t=> t === trigger)),
        tap((t) => console.log( 'permitted', t)));
    }

    
  
    fire$(trigger: TTrigger, ...args: any[]) {
      return from(this.wrapped.fire(trigger, args));
    }
  
    private updateSubjects() {
      from(this.wrapped.getPermittedTriggers()).subscribe((triggers: TTrigger[]) => {
        console.log('updateSubjects', triggers,  this.wrapped.state);
        this.stateSubject.next(this.wrapped.state);
        this.permittedTriggerSubject.next(triggers);
      })
    }
  
    constructor(private readonly wrapped: StateMachine<TState, TTrigger>) {
      wrapped.onTransitioned(() => this.updateSubjects());
    }
  
  
  }
  